import { render, staticRenderFns } from "./component-chart.vue?vue&type=template&id=988b5b04"
import script from "./component-chart.vue?vue&type=script&lang=js"
export * from "./component-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports